<template>
  <div class="view-check-list pad">

    <loading v-if="checkList === null" />

    <check-list v-if="checkList" :check-list="checkList" />

  </div>
</template>

<script>
import CheckList from '@/components/CheckList'
export default {
  name: 'ViewCheckList',
  components: {
    CheckList
  },
  data () {
    return {
      checkList: null,
      checkListId: null
    }
  },
  watch: {
    checkListId () {
      this.checkList = null
      if (!this.checkListId) {
        return
      }

      this.$firestore.collection('checkLists').doc(this.checkListId)
        .get()
        .then(doc => {
          this.checkList = this.$utils.docToObj(doc)
        })
    }
  },
  beforeRouteUpdate (to, from, next) {
    this.checkListId = to.params.id
    next()
  },
  created () {
    this.checkListId = this.$route.params.id
  }
}
</script>

<style>
  .view-check-list {
    height: 100%;
  }
</style>
